import { api } from "@/lib/api";
import { usePolling } from "@/hooks/usePolling";
import { LossLedgerTable } from "@/components/economics/LossLedgerTable";

export default function Quality() {
  const overview = usePolling(() => api.get("/quality/overview").then((r) => r.data), 8000);
  const ledger = usePolling(() => api.get("/intelligence/loss-ledger").then((r) => r.data), 8000);

  if (!overview.data) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="quality-loading">Loading…</div>;
  const d = overview.data;

  return (
    <div className="space-y-6" data-testid="quality-page">
      <h1 className="text-2xl font-bold font-heading text-[var(--oim-text)]">Data Quality</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
          <div className="text-sm font-heading font-bold text-[var(--oim-text)] mb-3">Tag basis breakdown</div>
          <div className="space-y-1 font-mono-data text-xs">
            {Object.entries(d.tag_basis_breakdown).map(([k, v]) => (
              <div key={k} className="flex justify-between"><span className="text-[var(--oim-text-muted)]">{k}</span><span className="text-[var(--oim-text)]">{v}</span></div>
            ))}
          </div>
        </div>
        <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
          <div className="text-sm font-heading font-bold text-[var(--oim-text)] mb-3">Observability by system</div>
          <div className="space-y-1 text-xs">
            {d.observability_by_system.map((o) => (
              <div key={o.system} className="flex justify-between"><span className="text-[var(--oim-text-muted)]">{o.system}</span><span className="text-[var(--oim-text-dim)] uppercase text-[10px]">{o.class}</span></div>
            ))}
          </div>
        </div>
        <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
          <div className="text-sm font-heading font-bold text-[var(--oim-text)] mb-3">AVR — {d.avr_unvalidated}/{d.avr_total} unvalidated</div>
          <div className="space-y-1 text-xs">
            {d.avr_unvalidated_list.map((a) => (
              <div key={a.avr_id} className="flex justify-between" data-testid={`avr-row-${a.avr_id}`}>
                <span className="text-[var(--oim-text-muted)]">{a.avr_id}</span>
                <span className="text-[10px]" style={{ color: "var(--oim-gold)" }}>class {a.avr_class}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
        <div className="text-sm font-heading font-bold text-[var(--oim-text)] mb-3">Measurement improvement roadmap</div>
        <div className="space-y-1 text-xs">
          {d.improvement_roadmap.map((r, i) => (
            <div key={i} className="flex justify-between">
              <span className="text-[var(--oim-text-secondary)]">{r.item}</span>
              <span className="font-mono-data text-[var(--oim-text)]">₹{r.value_unlocked_per_day.toLocaleString("en-IN")}/day</span>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
        <div className="text-sm font-heading font-bold text-[var(--oim-text)] mb-3">Loss Ledger</div>
        {ledger.data && <LossLedgerTable ledger={ledger.data} />}
      </div>
    </div>
  );
}
